import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Paper,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import CountUp from "react-countup";
import {
  deleteSingleObject,
  deleteUser,
  getData,
  signUpUser,
  updateData,
} from "../../../Config/FirebaseMethod";
import AddIcon from "@mui/icons-material/Add";

const PatientsData = () => {
  const [PateintData, setPateintData] = useState([]);
  const [isLoading, setisLoading] = useState(true);
  const [patientCount, setPatientCount] = useState(0);
  const [userID, setUserID] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [open, setOpen] = useState(false);
  let [list, setList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [opens, setOpens] = React.useState(false);
  const [Add, setAdd] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    id: "",
    firstName: "",
    lastName: "",
    blood: "",
    age: "",
    temp: "",
    bpu: "",
    gender: "",
    bpl: "",
    bpm: "",
    emg: "",
    check: "",
  });

  const PatientData = async () => {
    try {
      setisLoading(true);
      const res = await getData(`IqraHospital/`);

      setisLoading(false);

      const patient = res.filter((obj) => obj.category === "patient");
      setPateintData(patient);

      const patientCount = patient.length;
      setPatientCount(patientCount);
    } catch (err) {
      setisLoading(false);
      alert(err);
    }
  };

  let deleteItem = (id, listId, email, password) => {
    deleteUser("IqraHospital", listId, email, password)
      .then((res) => {
        setMsg(res);
        setOpen(true);
        setAlertSeverity("success");
        setAlertMessage(res);
      })
      .catch((err) => {
        setError(err);
        setAlertSeverity("error");
        setAlertMessage(err.message);
        setOpen(true);
      });
  };

  const [check, setCheck] = useState("check");

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleClickOpen = (
    i,
    id,
    firstName,
    lastName,
    blood,
    age,
    temp,
    bpu,
    gender,
    bpl,
    bpm,
    emg
  ) => {
    setOpens(true);
    setFormData({
      id: id || "",
      firstName: firstName || "",
      lastName: lastName || "",
      age: age || "",
      blood: blood || "",
      temp: temp || "",
      gender: gender || "",
      bpu: bpu || "",
      bpl: bpl || "",
      bpm: bpm || "",
      emg: emg || "",
      check: check || "",
    });
  };

  const handleClose = () => {
    setOpens(false);
  };

  const AddOpen = () => {
    setAdd(true);
  };

  const AddClose = () => {
    setAdd(false);
  };

  let handleSubmit = (e) => {
    e.preventDefault();

    const nodeName = "IqraHospital";
    const id = formData.id;
    setLoading(true);
    updateData(formData, nodeName, id)
      .then((message) => {
        setLoading(false);
        setAlertSeverity("success");
        setAlertMessage(message);
      })
      .catch((err) => {
        setLoading(false);
        setAlertSeverity("success");
        setAlertMessage(err);
      });
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const filteredData = PateintData.filter(
    (row) =>
      row.id.toLowerCase() === searchQuery.toLowerCase() ||
      row.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.category.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const displayedData = filteredData.slice(startIndex, endIndex);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Call the real-time function
        await PatientData();
      } catch (err) {
        // Handle any errors
        console.error(err);
      }
    };

    // Run the function initially
    fetchData();

    // Set up an interval to run the function periodically
    const interval = setInterval(fetchData, 2000); // Fetch data every 2 seconds

    // Clean up the interval when the component unmounts
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "80vh",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <Box>
                <Card sx={{ minWidth: 32 + "%", height: 150, borderRadius: 3 }}>
                  <Stack direction="row" spacing={40}>
                    <CardContent sx={{ padding: 5 }}>
                      <Typography gutterBottom variant="h5" component="div">
                        <CountUp
                          delay={0.2}
                          end={patientCount}
                          duration={0.3}
                        />
                      </Typography>
                      <Typography gutterBottom variant="body1" component="div">
                        Total Patient
                      </Typography>
                    </CardContent>
                    <CardContent sx={{ padding: 5 }}>
                      <Typography gutterBottom variant="h3" component="div">
                        Patient Data
                      </Typography>
                    </CardContent>
                  </Stack>
                </Card>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Paper>
                <Card
                  sx={{ minWidth: 32 + "%", height: "auto", borderRadius: 3 }}
                >
                  <Container
                    className="mt-5 mb-5"
                    sx={{ maxWidth: "100%", overflowX: "auto" }}
                  >
                    <Box mt={3}>
                      <TextField
                        id="outlined-basic"
                        label="Search"
                        variant="outlined"
                        sx={{ width: 300 }}
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                    </Box>

                    <Box mt={7} />

                    <TableContainer
                      sx={{
                        "&::-webkit-scrollbar": {
                          width: "0.6px",
                          height: "0.6em",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#888",
                        },
                      }}
                    >
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>Patient.ID</TableCell>
                            <TableCell>First Name</TableCell>
                            <TableCell>Last Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Age</TableCell>
                            <TableCell>Blood</TableCell>
                            <TableCell>Gender</TableCell>
                            <TableCell>Temp</TableCell>
                            <TableCell>EMG</TableCell>
                            <TableCell>BPM</TableCell>
                            <TableCell>BPU</TableCell>
                            <TableCell>BPL</TableCell>
                            <TableCell>Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {displayedData.map((row, i) => (
                            <TableRow key={i}>
                              <TableCell>{row.id}</TableCell>
                              <TableCell>{row.firstName}</TableCell>
                              <TableCell>{row.lastName}</TableCell>
                              <TableCell>{row.email}</TableCell>
                              <TableCell>{row.age}</TableCell>
                              <TableCell>{row.blood}</TableCell>
                              <TableCell>{row.gender}</TableCell>
                              <TableCell>{row.temp}</TableCell>
                              <TableCell>{row.emg}</TableCell>
                              <TableCell>{row.bpm}</TableCell>
                              <TableCell>{row.bpu}</TableCell>
                              <TableCell>{row.bpl}</TableCell>

                              <TableCell>
                                <Stack direction="row" spacing={2}>
                                  <button
                                    className="btn btn-danger"
                                    onClick={() =>
                                      deleteItem(
                                        i,
                                        row.id,
                                        row.email,
                                        row.password
                                      )
                                    }
                                  >
                                    Delete
                                  </button>
                                  <button
                                    onClick={() =>
                                      handleClickOpen(
                                        i,
                                        row.id,
                                        row.firstName,
                                        row.lastName,
                                        row.blood,
                                        row.age,
                                        row.temp,
                                        row.bpu,
                                        row.gender,
                                        row.bpl,
                                        row.bpm,
                                        row.emg
                                      )
                                    }
                                    className="btn btn-success"
                                  >
                                    Edit
                                  </button>
                                </Stack>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <div className="conatiner mt-2">
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </div>
                  </Container>
                </Card>
              </Paper>
            </Grid>
          </Grid>

          <div>
            <Dialog open={opens} onClose={handleClose}>
              <form onSubmit={handleSubmit}>
                <DialogTitle>Edit The User</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Fill This Form Below To Edit User Data
                  </DialogContentText>
                  <Stack direction="row" spacing={2} mt={3}>
                    <TextField
                      id="name"
                      label="First Name"
                      type="text"
                      variant="standard"
                      value={formData.firstName}
                      onChange={handleChange}
                    />
                    <TextField
                      label="Last Name"
                      type="text"
                      variant="standard"
                      name=""
                      value={formData.lastName}
                      onChange={handleChange}
                    />
                  </Stack>
                  <Stack direction="row" spacing={2} mt={3}>
                    <TextField
                      label="Age"
                      type="text"
                      variant="standard"
                      name="age"
                      value={formData.age}
                      onChange={handleChange}
                    />
                    <TextField
                      label="Blood"
                      type="text"
                      variant="standard"
                      name="blood"
                      value={formData.blood}
                      onChange={handleChange}
                    />
                  </Stack>
                  <Stack direction="row" spacing={2} mt={3}>
                    <TextField
                      label="Temp"
                      type="text"
                      variant="standard"
                      name="temp"
                      value={formData.temp}
                      onChange={handleChange}
                    />
                    <TextField
                      label="EMG"
                      type="text"
                      variant="standard"
                      name="emg"
                      value={formData.emg}
                      onChange={handleChange}
                    />
                  </Stack>
                  <Stack direction="row" spacing={2} mt={3}>
                    <TextField
                      label="BPM"
                      type="text"
                      variant="standard"
                      name="bpm"
                      value={formData.bpm}
                      onChange={handleChange}
                    />
                    <TextField
                      label="BPU"
                      type="text"
                      variant="standard"
                      name="bpu"
                      value={formData.bpu}
                      onChange={handleChange}
                    />
                  </Stack>
                  <Stack direction="row" spacing={2} mt={3}>
                    <TextField
                      label="BPL"
                      type="text"
                      variant="standard"
                      name="bpl"
                      value={formData.bpl}
                      onChange={handleChange}
                    />
                    <TextField
                      label="Gender"
                      type="text"
                      variant="standard"
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                    />
                  </Stack>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button type="submit">
                    {loading ? <CircularProgress /> : "Add"}
                  </Button>
                </DialogActions>
              </form>
            </Dialog>
          </div>

          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleSnackbarClose}
          >
            <Alert severity={alertSeverity} sx={{ width: "100%" }}>
              {alertMessage}
            </Alert>
          </Snackbar>
        </Box>
      )}
    </>
  );
};

export default PatientsData;
